// @core/api/endpoints/attachment/index.ts
// Auto-generated by corebuilder. DO NOT EDIT.
import { AbortMultipartUpload } from './abort_multipart_upload';
import { CompleteMultipartUpload } from './complete_multipart_upload';
import { ConfirmUpload } from './confirm_upload';
import { DeleteAttachment } from './delete_attachment';
import { DeleteAttachmentsBulk } from './delete_attachments_bulk';
import { GetAttachment } from './get_attachment';
import { GetDownloadUrl } from './get_download_url';
import { GetDownloadUrlsBulk } from './get_download_urls_bulk';
import { GetMultipartUploadPartUrl } from './get_multipart_upload_part_url';
import { GetOwnershipHistory } from './get_ownership_history';
import { GetProcessingStatus } from './get_processing_status';
import { GetUploadUrl } from './get_upload_url';
import { InitiateMultipartUpload } from './initiate_multipart_upload';
import { ListAttachments } from './list_attachments';
import { ListAttachmentsByIDs } from './list_attachments_by_ids';
import { ListAttachmentsByOwner } from './list_attachments_by_owner';
import { RetryProcessing } from './retry_processing';
import { TransferOwnership } from './transfer_ownership';
import { UpdateAttachment } from './update_attachment';

// Re-export individual endpoints
export {
  AbortMultipartUpload,
  CompleteMultipartUpload,
  ConfirmUpload,
  DeleteAttachment,
  DeleteAttachmentsBulk,
  GetAttachment,
  GetDownloadUrl,
  GetDownloadUrlsBulk,
  GetMultipartUploadPartUrl,
  GetOwnershipHistory,
  GetProcessingStatus,
  GetUploadUrl,
  InitiateMultipartUpload,
  ListAttachments,
  ListAttachmentsByIDs,
  ListAttachmentsByOwner,
  RetryProcessing,
  TransferOwnership,
  UpdateAttachment,
};

// Namespace export for convenient usage
export const attachmentApi = {
  AbortMultipartUpload,
  CompleteMultipartUpload,
  ConfirmUpload,
  DeleteAttachment,
  DeleteAttachmentsBulk,
  GetAttachment,
  GetDownloadUrl,
  GetDownloadUrlsBulk,
  GetMultipartUploadPartUrl,
  GetOwnershipHistory,
  GetProcessingStatus,
  GetUploadUrl,
  InitiateMultipartUpload,
  ListAttachments,
  ListAttachmentsByIDs,
  ListAttachmentsByOwner,
  RetryProcessing,
  TransferOwnership,
  UpdateAttachment,
};
